<template>
  <section class="container-wrapper error-page">
    <h1 v-if="title" class="error-page__title">
      {{ title }}
    </h1>
    <p class="error-page__text">
      {{ text }}
    </p>
    <div
      v-show="buttonText"
      class="error-page__button-wrapper"
    >
      <BaseButton
        class="error-page__button"
        @click="navigateHome"
      >
        {{ buttonText }}
      </BaseButton>
    </div>
  </section>
</template>

<script>
  import { mapState } from 'vuex'
  import { get } from 'lodash'

  export default {
    name: 'NotFoundPage',
    data () {
      return {
        from404: {}
      }
    },
    computed: {
      ...mapState(['main', 'globalData']),
      title () {
        return get(this.$route, 'params.title') || get(this, 'main.notFound.title')
      },
      text () {
        return get(this.$route, 'params.description') || get(this, 'main.notFound.description')
      },
      buttonText () {
        return get(this.$route, 'params.buttonText') || get(this, 'main.notFound.button')
      }
    },
    methods: {
      navigateHome () {
        if (get(this.$route, 'params.goBack') === true) {
          this.$router.go(-1)
          return
        }
        this.$router.push('/service')
      }
    }
  }
</script>

<style lang="scss">
  .error-page {
    &__text {
      text-align: center;
    }

    &__button {
      margin-top: 50px;

      @include mobile {
        margin-top: 25px;
      }

      &-wrapper {
        display: flex;
        justify-content: center;
      }
    }
  }
</style>
